module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074fe_banner_800x600.5fe3fdc4.png";